import {setup} from '../../snippets/python';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  'run-server': {
    Component: CreateShellCommand('python3 -m flask run --port=4242'),
  },
};

export default ({
  keys,
  merchant,
  client,
  activePrice,
  checkoutMode,
  demo: {paymentMethods},
}) => `#! /usr/bin/env python3.6

"""
server.py
Stripe Sample.
Python 3.6 or newer required.
"""
import os
from flask import Flask, redirect, request

{+setup}
import stripe
${comment && comment(merchant, '#')}
stripe.api_key = '${keys.secret}'
{/setup}

app = Flask(__name__,
            static_url_path='',
            static_folder='public')

YOUR_DOMAIN = '${
  client === 'react'
    ? 'http://localhost:3000/checkout'
    : 'http://localhost:4242'
}'

@app.route('/create-checkout-session', methods=['POST'])
def create_checkout_session():
    try:
    {+create}
        {span response create}checkout_session{/span} = stripe.checkout.Session.create(
            {?customize prefill-email}
            customer_email='customer@example.com',
            {/prefill-email}
            {?customize submit-button}
            submit_type='donate',
            {/submit-button}
            {?customize address}
            billing_address_collection='auto',
            shipping_address_collection={
              'allowed_countries': ['US', 'CA'],
            },
            {/address}
            {+line-items}
            line_items=[
                {
                    ${
                      activePrice
                        ? `'price': '${activePrice.id}'`
                        : `# TODO: replace this with the \`price\` of the product you want to sell
                    'price': '{{PRICE_ID}}'`
                    },
                    'quantity': 1,
                },
            ],
            {/line-items}
            {+payment-methods}
            payment_method_types=[
              ${
                paymentMethods.length
                  ? paymentMethods
                      .map((key) => `'${key}',`)
                      .join('\n              ')
                  : '# TODO: pass at least one option here'
              }
            ],
            {/payment-methods}
            {+mode}
            mode='${checkoutMode}',
            {/mode}
            {+urls}
            success_url=YOUR_DOMAIN + '${
              client === 'react' ? '?success=true' : '/success.html'
            }',
            cancel_url=YOUR_DOMAIN + '${
              client === 'react' ? '?canceled=true' : '/cancel.html'
            }',
            {/urls}
            {?automatic-tax automatic-tax-param}
            automatic_tax={'enabled': True},
            {/automatic-tax-param}
        )
    {/create}
    except Exception as e:
        return str(e)

    {+redirect}
    return redirect(checkout_session.url, code=303)
    {/redirect}

if __name__ == '__main__':
    app.run(port=4242)
`;
